export default "__VITE_ASSET__mKPPF_5$__"